<template>
    <div v-if="active">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            subtitle: {
                type: String | Number,
                default: ''
            },
        },

        data() {
            return {
                active: false
            }
        },

        mounted() {
            this.$parent.addTab(this);
        }

    }
</script>
